module.exports = __webpack_public_path__ + "static/media/hand-holding.8db231c6.svg";